module.exports = __webpack_public_path__ + "static/img/lres1.2e5dd1a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/lres1.png
// module id = Y1e1
// module chunks = 1